import { render, staticRenderFns } from "./sentItemsTranspond.vue?vue&type=template&id=35595b63&scoped=true&"
import script from "./sentItemsTranspond.vue?vue&type=script&lang=js&"
export * from "./sentItemsTranspond.vue?vue&type=script&lang=js&"
import style0 from "./sentItemsTranspond.vue?vue&type=style&index=0&id=35595b63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35595b63",
  null
  
)

export default component.exports